var React = require('react');

function Next (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 16L9 8.5L1 0.999999","stroke":"black","strokeWidth":"2.5"}));
}

Next.defaultProps = {"width":"11","height":"17","viewBox":"0 0 11 17","fill":"none"};

module.exports = Next;

Next.default = Next;
